const RouterRole = {
  PUBLIC: 'public',
  PROTECTED: 'protected',
};

export default RouterRole;
